module.exports = __webpack_public_path__ + "static/media/Engpic3.12f4294f.png";